import http from "../../http-common";
class MenuSupportService {
    getSupportSearch(){
        return http.get(`/menu/support/search`);
    }
    createSupport(data) {
        return http.post(`/menu/support`, data);
    }
    updateSupport(data) {
        return http.put(`/menu/support`, data);
    }
    deleteSupport(id) {
        return http.delete(`/menu/support/${id}`);
    }

    //Chức năng lấy tất cả dữ liệu trong bảng menu_support để lấy ra link
    getSupportSearchDashboard(){
        return http.get(`/dashboard/support/search`);
    }
}
export default new MenuSupportService();